import { YelpSearch } from "../interfaces/yelp";

// stores points of interest in a list of results
export interface PoiSearch {
    result: YelpSearch;
    poiindex: number;
}

export function getPoiLatLng(poi:PoiSearch): google.maps.LatLngLiteral {
    const latlngYelp = poi.result.coordinates;
    return { lat: latlngYelp.latitude, lng: latlngYelp.longitude };
}

export async function getPois(latlng: google.maps.LatLngLiteral, term: string, token: string):
    Promise<Array<PoiSearch>> {
    const url = "/api/PointOfInterest/Search?latlng=" +
        encodeURIComponent(new google.maps.LatLng(latlng).toUrlValue()) +
        "&term=" +
        encodeURIComponent(term) +
        "&token=" +
        encodeURIComponent(token);

    const response = await fetch(url);
    const responsejson = await response.json();
    const businesses: Array<YelpSearch> = responsejson.businesses;
    const poiList = businesses.map(function (result, index) {
        const poisearch: PoiSearch = {
            result: result,
            poiindex: index,
        };
        return poisearch;
    });

    return poiList;
}